<div
  class="tab-pane fade flex-even active show"
  id="contacts"
  role="tabpanel"
  aria-labelledby="contacts-tab"
>
  @if (this.contactDetail$ | async; as contactDetail) {
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-8 col-md-8">
          <div class="ps-3">
            <button
              type="button"
              [class]="ButtonType.Primary | buttontypepipe"
              class="btn-sm btn"
              translate
              (click)="
              openModalCreatePayment(contactDetail.id, contactDetail.isCompany)
            "
            >
              CONTACT_LBL_PAYMENT_ADD
            </button>
            @if (contactDetail.isCompany) {
              <button
                type="button"
                [class]="ButtonType.Primary | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalSlipContent(contactDetail.id)"
              >
                CONTACT_LBL_IMPORT_SLIP
              </button>
            } @else {
              <button
                type="button"
                [class]="ButtonType.Primary | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalCreateReimbursement(contactDetail.id)"
              >
                CONTACT_LBL_REIMBURSEMENT_ADD
              </button>
              <button
                type="button"
                [class]="ButtonType.Light | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalBindAccountMoves(contactDetail.id)"
              >
                PAYMENT_LBL_BIND_PAYMENT
              </button>
            }
          </div>
        </div>
        <div class="col ms-auto text-end align-self-center">
          @if (contactDetail.accountMoves.length === 300) {
            <i>Résultats limités aux 300 plus récents</i>
          }
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <table class="table table-striped border-bottom">
            <thead>
            <tr>
              <th>
                <a translate>PAYMENT_LBL_DATE</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_AMOUNT</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_MODE</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_PROOF</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_STATUS</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_ACTIONS</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_ACCOUNT_MOVE_BINDED</a>
              </th>
            </tr>
            </thead>

            <tbody>
              @for (accountMove of contactDetail.accountMoves; track accountMove.id) {
                <ng-container class="row-action">
                  @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                    <tr>
                      <td>
                        {{ accountMoveLine.creationDate | date : "dd/MM/yyyy" }}
                      </td>
                      <td>
                        <app-colored-amount [amountValue]="accountMoveLine.unitPriceClientView" />
                      </td>
                      <td>{{ accountMoveLine.paymentModeLoc }}</td>
                      <td>
                        @if (!accountMoveLine.documentId) {
                          <app-generic-file-input
                            [format]="'link'"
                            [isValidationButton]="false"
                            [isClearButton]="false"
                            (fileEmitter)="onValidationEmitterUploadFile($event, accountMoveLine.id, contactDetail.id)"
                            [clearFile]="this.clearFile()"
                          />
                        }
                        @if (accountMoveLine.documentId) {
                          <a
                            role="button"
                            (click)="onClickShowDocument(accountMoveLine.documentId)"
                            translate
                          >PAYMENT_LBL_SHOW_DOCUMENT</a>
<!--                          @if (accountMoveLine.paymentMode === 'Cash' && !accountMove.isReadOnly) {-->
                          @if (accountMove.contractStatusId === ContractStatus.Draft || accountMove.contractStatusId === ContractStatus.ContractRequest) {
                            |
                            <app-generic-file-input
                              [format]="'link'"
                              [isValidationButton]="false"
                              [isClearButton]="false"
                              (fileEmitter)="onValidationEmitterUploadFile($event,accountMoveLine.id,contactDetail.id)"
                              [clearFile]="this.clearFile()"
                            />
                          }
                        }
                      </td>
                      <td>{{ accountMove.statusLoc }}</td>
                      <td>
                        @for (action of accountMove.actions; track action.name; let last = $last) {
                          <a role="button"
                             (click)="this.triggerAction(action.name,accountMove.id,contactDetail.id)"
                             translate
                          >{{ action.actionName }}{{ last ? "" : " | " }}</a>
                        }
                      </td>
                      <td>
                        @if (accountMove.issuingAccountMoves.length == 0 && accountMove.status != 'Cancel') {
                          <a role="button"
                             (click)="openModalBindAccountMoves(contactDetail.id,accountMove.id)"
                             translate
                          >PAYMENT_LBL_BIND_ACCOUNT_MOVE</a>
                        }
                        @if (accountMove.issuingAccountMoves.length > 0) {
                          <a role="button"
                             (click)="openModalBindAccountMovesDetails(contactDetail.id,
                                                                       accountMove,
                                                                       accountMove.issuingAccountMoves,
                                                                       accountMove.isReadOnly,
                                                                       accountMove.isAdminOnly)"
                             translate
                          >{{
                              accountMove.issuingAccountMoves
                                | showInvoiceAndTruncate : [50]
                            }}
                          </a>
                        }
                      </td>
                    </tr>
                  }
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
</div>
